const al = {
  // My Offers
  catalogue_title_screen: 'Ofertat e mia',
  catalogue_title_section_recommended: 'Rekomandim për ty',
  catalogue_title_section_filters: 'Filtro',
  catalogue_label_recommended: 'Rekomandim për ty',
  catalogue_label_filters_all: 'Të gjitha',
  catalogue_label_something_went_wrong: 'Diçka nuk funksionoi',
  catalogue_action_retry: 'Provo përsëri',
  catalogue_action_retry_later: 'Provo më vonë',
  catalogue_action_go_back: 'Kthehu',

  // Details
  catalogue_details_label_duration: ' %2$s',
  catalogue_details_label_validity: 'Vlefshmëria',
  catalogue_details_label_show_more: 'Më shumë',
  catalogue_details_label_show_less: 'Më pak',
  catalogue_details_action_buy: 'Bli',

  // Payment
  catalogue_payment_type_airtime: 'Balancë',
  catalogue_payment_type_creditcard: 'Kartë krediti',
  catalogue_payment_type_bill: 'Faturë',
  catalogue_payment_type_loan: 'Merr Hua',
  catalogue_payment_step_select: 'Pagesë',
  catalogue_payment_step_confirm: 'Aktivizim pakete',
  catalogue_payment_step_loading: '',
  catalogue_payment_step_loan: 'Aktivizim pakete',
  catalogue_payment_step_overwrite: 'Mbivendosje pakete',
  catalogue_payment_step_error: '',
  catalogue_payment_step_success: 'Aktivizim pakete',
  catalogue_payment_label: 'Pagesa',
  catalogue_payment_label_payment_methods: 'Mënyrat e pagesës',
  catalogue_payment_label_attention: 'Kujdes',
  catalogue_payment_label_cost: 'Kosto ',
  catalogue_payment_label_congrats: 'Urime!',
  catalogue_payment_label_cta_p2h: 'Zbulo tani',
  catalogue_payment_label_cta_renewal: 'Zbulo tani',
  catalogue_payment_label_cta_refill: 'Aktivizo tani',
  catalogue_payment_label_cta_details: 'Aktivizo tani',
  catalogue_payment_label_cta_shake: 'Shake tani',
  catalogue_payment_label_cta_flowerbox: 'Aktivizo tani',
  catalogue_payment_label_cta_topup: 'Aktivizo tani',
  catalogue_payment_label_cta_ebill: 'Paguaj tani',
  catalogue_payment_label_cta_gigafamily: 'Zbulo tani',
  catalogue_payment_label_cta_tidal: 'Zbulo tani',
  catalogue_payment_label_cta_undefined: 'Më Shumë',
  catalogue_payment_desc_bundle_activated: 'Paketa juaj u aktivizua me sukses.',
  catalogue_payment_desc_next_bill: 'Ti do të tarifohesh në faturën e rradhës.',
  catalogue_payment_desc_activation_confirm: 'A je i sigurtë që do të aktivizosh këtë paketë?',
  catalogue_payment_desc_overwrite: 'Aktivizimi i paketës %1$s do të mbishkruajë një ose disa nga paketat tuaja aktive. Dëshironi të vazhdoni?',
  catalogue_payment_desc_loan_confirm: 'Huaja bashkë me një tarifë shtesë prej %1$s %2$s do të shlyhet me rimbushjen tënde të rradhës.',
  catalogue_payment_title_loan_confirm: 'Je i/e sigurt që do të aktivizosh këtë paketë duke marrë hua %1$s %2$s?',
  catalogue_payment_action_confirm: 'Konfirmo',
  catalogue_payment_action_back: 'Kthehu',
  catalogue_payment_action_continue: 'Vazhdo',
  catalogue_payment_action_overwrite: 'Mbivendos',
  catalogue_payment_action_cancel: 'Anullo',
  catalogue_payment_price_unit: '%1$s %2$s',
  catalogue_payment_url_tidal: 'https://offers.vodafone.com/al',

  // Others
  addons_sub_text: '%1$s %2$s',
}

export default al
